// extracted by css-extract-rspack-plugin
export default {"email":"email-qjqogc"};